import { Contract } from 'cpie-common';

type CommonFieldNameType = 'productType' | 'productFamily' | 'productTypeIE' | 'contractNumber' | 'contractType';

export const getCommonProductField = (fieldName: CommonFieldNameType, arr?: Contract[]): string => {
    if (!arr?.length) return 'None';

    const items = (arr as unknown) as Record<CommonFieldNameType, string | undefined>[];
    const uniqueTypes = new Set(items.map(item => item[fieldName]));

    if (uniqueTypes.size === 1) {
        return items[0][fieldName] || 'None';
    }

    return 'Multiple';
};
